<template>
  <div class="tender-keywords">
    <div class="tender-keywords__loading" v-if="loading">
      <BaseTag skeleton />
      <span class="tender-keywords__loading-text">{{ $t('tender-details.searching-keywords') }}</span>
    </div>
    <div v-else class="tender-keywords__matches">
      <BaseTag v-if="hasMatches" tone="info" preset="primary" icon="type">
        <template v-if="isExploreMode">
          {{ $tc('page.tenders.covered-by-keywords', keywords.length, { count: keywords.length }) }}
        </template>
        <template v-else>
          {{ keywords.length }}
          {{ $tc('basic-words.keywords', keywords.length) }}
        </template>
      </BaseTag>
      <BaseTag v-else tone="warning" preset="primary" icon="type">
        {{ $t('page.tenders.not-covered-by-keywords') }}
      </BaseTag>
      <ul v-if="hasMatches" class="tender-keywords__list">
        :
        <Keyword v-for="keyword in keywords" :key="keyword" isResult>
          {{ keyword }}
        </Keyword>
      </ul>
    </div>
  </div>
</template>

<script>
import BaseTag from '@/components/base/BaseTag';
import Keyword from '@/components/page-keywords/Keyword';
import { Modes } from '@/models/modes';
import { mapGetters } from 'vuex';

export default {
  name: 'TenderKeywords',
  components: {
    BaseTag,
    Keyword,
  },
  props: {
    keywords: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('modes', ['mode']),
    hasMatches() {
      return this.keywords.length > 0;
    },
    isExploreMode() {
      return this.mode === Modes.EXPLORE.name;
    },
  },
};
</script>
<style lang="scss">
.tender-keywords {
  flex: 1;
  display: flex;

  &__matches,
  &__loading {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__loading-text {
    color: $color-normal-pale;
  }

  &__list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
}
</style>
